let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fKuf2")).then(() => parcelRequire('dvmRd'));